import i18n from 'i18next';

const SUPPORTED_LOCALES = ['en', 'nl', 'de', 'dk', 'fr'];

/**
 * Persists the locale and switches the live i18n language to match.
 * Components call useTranslation(localStorage.getItem('locale')), where the
 * namespace equals the locale, so i18n.language must follow localStorage or
 * lookups miss and raw keys render until the next full page load.
 */
const setAppLocale = async (locale: string | null | undefined): Promise<void> => {
  if (!locale || !SUPPORTED_LOCALES.includes(locale)) {
    return;
  }

  localStorage.setItem('locale', locale);

  if (i18n.language !== locale) {
    await i18n.changeLanguage(locale);
  }
};

export default setAppLocale;
